var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-buildify-page.ts
import { logger } from "@adornis/base/logging.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import "@adornis/chemistry/elements/components/x-empty-placeholder.js";
import { XSnackbar } from "@adornis/chemistry/elements/components/x-snackbar.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import "@adornis/fonts/fonts.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { firstValueFrom, timer } from "rxjs";
import { BuildifyGlobalSettings } from "../db/GlobalSettings.js";
import "../db/Page.js";
import "./components/x-buildify-color-picker.js";
import "./components/x-buildify-page-settings.js";
import { DocumentExtension } from "./extensions/DocumentExtension.js";
import { Size } from "./globals/enums.js";
import "./x-buildify.js";
var XBuildifyPage = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.page = new RXController(this, void 0);
    this.extensions = [];
    this.documentExtension = DocumentExtension;
    this.options = [];
    this.sizeBreakpoints = {
      [Size.DESKTOP]: 1200,
      [Size.TABLET]: 992,
      [Size.MOBILE]: 768
    };
    this.isEditor = false;
    this.globalSettingsClassName = new RXController(this, BuildifyGlobalSettings._class);
    this._pageMetaDataDrawer = createRef();
  }
  shouldUpdate(_changedProperties) {
    return super.shouldUpdate(_changedProperties) && !this.page.isLoading;
  }
  render() {
    const page = this.page.value;
    if (!page)
      return html` <x-empty-placeholder .text=${"404"} .img=${close}></x-empty-placeholder> `;
    return xComponents(html`
      <x-buildify
        .value=${page.content}
        .extensions=${this.extensions}
        .options=${this.options.concat([
      {
        icon: "edit_document",
        tooltip: () => xComponents(html` <x-text> Seiten-Einstellungen </x-text> `),
        action: () => this._pageMetaDataDrawer.value?.open()
      },
      {
        icon: "save",
        tooltip: () => xComponents(html` <x-text> Seite speichern </x-text> `),
        action: async (value) => {
          try {
            page.content = value;
            await XDialog.waitFor(Promise.all([firstValueFrom(timer(150)), page.save()]));
            void XSnackbar.show("Seite wurde erfolgreich gespeichert");
          } catch (e) {
            logger.error({ err: e }, "Es gab ein Problem beim Speichern einer Buildify Seite");
            void XDialog.alert("Es gab ein Problem beim Speichern. Bitte versuchen Sie es sp\xE4ter erneut");
          }
        }
      }
    ])}
        .documentExtension=${this.documentExtension}
        .sizeBreakpoints=${this.sizeBreakpoints}
        ?editor=${this.isEditor}
        .autoScrollContainer=${this.autoScrollContainer}
        .globalSettingsClassName=${this.globalSettingsClassName}
      >
      ${this._editPageMetaData()}
      </x-buildify>
    `);
  }
  _editPageMetaData() {
    return html`
      <x-drawer-panel ${ref(this._pageMetaDataDrawer)}>
        <x-buildify-page-settings
          .page=${this.page.value}
          @cancel=${() => this._pageMetaDataDrawer.value?.close()}
          @success=${() => {
      this._pageMetaDataDrawer.value?.close();
      this.dispatchEvent(new CustomEvent("page-settings-success", {}));
    }}
          .pageSettingsConfig=${this.pageSettingsConfig}
        ></x-buildify-page-settings>
      </x-drawer-panel>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          background: this.page.value?.metaData?.backgroundColor ?? "",
          color: this.page.value?.metaData?.color ?? ""
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "page", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "extensions", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "documentExtension", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "options", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "sizeBreakpoints", 2);
__decorateClass([
  property({ attribute: "editor", type: Boolean })
], XBuildifyPage.prototype, "isEditor", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "autoScrollContainer", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "pageSettingsConfig", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPage.prototype, "globalSettingsClassName", 2);
XBuildifyPage = __decorateClass([
  customElement("x-buildify-page")
], XBuildifyPage);
export {
  XBuildifyPage
};
